import { render, staticRenderFns } from "./videodetail.vue?vue&type=template&id=71e400a1&scoped=true&"
import script from "./videodetail.vue?vue&type=script&lang=js&"
export * from "./videodetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e400a1",
  null
  
)

export default component.exports